import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';

export const uploadStatusCodeMock = async () => {
  const data = { code: 200 };
  axiosMock.onPut(API_URL.uploadItems).reply(200, data);
};
